function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onChange"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import { Field, FieldArray, Form as FormikForm, Formik, getIn } from "formik";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./Employees.css";
import { ADD_USER_MUTATION, GENERATE_INVITE_LINK_QUERY, GET_INVITE_LINK_HISTORY_QUERY, ORGANISATION_USERS_QUERY, UPDATE_NEW_EMPLOYEE_TRANSACTION_DEATILS_MUTATION, GET_PAID_AND_UNUSED_USER_COUNT_QUERY, ORGANISATION_USERS_COUNT_QUERY, ORGANISATION_TEAMS_QUERY } from "./query";
import { TEAM_DETAILS_QUERY } from "../Teams/query";
import { GENERATE_CHECKOUT_NEW_URL_MUTATION, BILLING_CURRENCY_DETAILS_QUERY } from "../Billing/query";
import { ORGANISATION_DETAILS_QUERY } from "../SideMenu/query";
import { GoTriangleDown } from "react-icons/go";
import Loader from "./../Loader/Loader";
import { isRateLimited } from "../utils";
import moment from "moment-timezone";
import { MdEmail, MdLink } from "react-icons/md";
import { FilterContext, UserContext, SearchContext } from "../index";
import * as Yup from "yup";
import Table from "react-bootstrap/Table";
import { toast } from "react-toastify";
var UserSchema = Yup.object().shape({
  email: Yup.string().trim().email("Enter a valid email").required("Required").matches(/^[^\s@+]+@[^\s@]+\.[^\s@]+$/, "The '+' symbol is not allowed."),
  displayName: Yup.string().trim().required("Required").matches(/^[\u4E00-\u9FFF A-Za-z0-9'.-]+$/, "Invalid characters"),
  employeeId: Yup.string().trim().max(15, "Employee ID cannot exceed 15 characters."),
  teams: Yup.array().of(Yup.object().shape({
    teamId: Yup.string().required("Required"),
    roleId: Yup.string().required("Required")
  })).required("Please add teams").min(1, "Add atleast 1 team")
  // 🔥 ADD THIS BLOCK
  .test("unique-team", "A person cannot be assigned to the same team more than once.", function (teams) {
    if (!teams) return true;
    var filtered = teams.map(function (t) {
      return t.teamId;
    }).filter(function (id) {
      return id && id !== "allTeam";
    });
    return new Set(filtered).size === filtered.length;
  })
});
var AddUsersSchema = Yup.object().shape({
  users: Yup.array().of(UserSchema).required("Please add users").min(1, "Add atleast 1 user")
});
var defaultValues = {
  users: [{
    displayName: "",
    email: "",
    teams: [{
      teamId: "",
      roleId: ""
    }],
    employeeId: ""
  }]
};
var errorMessage = function errorMessage(errors, touched, name) {
  var error = getIn(errors, name);
  var touch = getIn(touched, name);
  if (touch && error) {
    return /*#__PURE__*/React.createElement(Form.Label, {
      className: "error"
    }, error);
  }
  return null;
};
export var AddEmployees = /*#__PURE__*/React.memo(function NewEmployeeModal(props) {
  var _paidUserCount$getPai2, _paidUserCount$getPai4, _paidUserCount$getPai5, _paidUserCount$getPai6, _paidUserCount$getPai7, _paidUserCount$getPai8;
  var show = props.show,
    handleClose = props.handleClose,
    inviteType = props.inviteType,
    setInviteType = props.setInviteType,
    teamId = props.teamId,
    urlPath = props.urlPath,
    organisationBilling = props.organisationBilling,
    employeeCount = props.employeeCount,
    role = props.role;
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var userId = user === null || user === void 0 ? void 0 : user.userId;
  var planId = organisationBilling.planId;
  var _React$useState = React.useState(1),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    userCount = _React$useState2[0],
    setUserCount = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    paymentStatus = _React$useState4[0],
    setPaymentStatus = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    licenseValidation = _React$useState6[0],
    setLicenseValidation = _React$useState6[1];
  var _React$useState7 = React.useState("INR"),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    chargebeeCurrency = _React$useState8[0],
    setChargebeeCurrency = _React$useState8[1];
  var timeZoneName = organisationSettings.organisationTimezone;
  // if (urlPath !== "/settings/manage-employees") {
  //   const { data, error, loading } = useQuery(ORGANISATION_USERS_QUERY, {
  //     variables: {
  //       organisationId,
  //       teamId,
  //     },
  //   });
  // }

  // const {
  //   data: paidUserCount,
  //   error,
  //   loading: paidUserLoading,
  //   refetch: paidUserRefetch,
  // } = useQuery(GET_PAID_AND_UNUSED_USER_COUNT_QUERY, {
  //   variables: {
  //     organisationId,
  //   },
  //   skip: organisationBilling?.planName == "free" || organisationBilling?.isTrial == true,
  //   fetchPolicy: "network-only",
  // });

  var _useQuery = useQuery(BILLING_CURRENCY_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    billingCurrencyData = _useQuery.data,
    billingCurrencyError = _useQuery.error,
    billingCurrencyLoading = _useQuery.loading;
  var _useQuery2 = useQuery(ORGANISATION_TEAMS_QUERY, {
      variables: {
        organisationId: organisationId
      },
      fetchPolicy: "network-only"
    }),
    teamsData = _useQuery2.data,
    teamError = _useQuery2.error,
    teamsLoading = _useQuery2.loading,
    teamsRefetch = _useQuery2.refetch;
  var _useLazyQuery = useLazyQuery(GET_PAID_AND_UNUSED_USER_COUNT_QUERY, {
      variables: {
        organisationId: organisationId
      },
      fetchPolicy: "network-only"
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getPaidUserDetails = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    paidUserCount = _useLazyQuery2$.data,
    error = _useLazyQuery2$.error,
    paidUserLoading = _useLazyQuery2$.loading;
  React.useEffect(function () {
    setChargebeeCurrency(billingCurrencyData !== null && billingCurrencyData !== void 0 && billingCurrencyData.billingCurrencyDetails ? billingCurrencyData === null || billingCurrencyData === void 0 ? void 0 : billingCurrencyData.billingCurrencyDetails : timeZoneName !== "Asia/Kolkata" ? "USD" : "INR");
  }, [billingCurrencyData === null || billingCurrencyData === void 0 ? void 0 : billingCurrencyData.billingCurrencyDetails]);
  React.useEffect(function () {
    teamsRefetch === null || teamsRefetch === void 0 ? void 0 : teamsRefetch();
    if (show) {
      if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.isTrial) == false) {
        getPaidUserDetails();
      }
    }
  }, [show]);
  React.useEffect(function () {
    var _paidUserCount$getPai;
    if (Number(paidUserCount === null || paidUserCount === void 0 ? void 0 : (_paidUserCount$getPai = paidUserCount.getPaidAndUnusedUserCount) === null || _paidUserCount$getPai === void 0 ? void 0 : _paidUserCount$getPai.userCount) > 0 && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.isTrial) == false) {
      setPaymentStatus(true);
    } else {
      setPaymentStatus(false);
    }
  }, [paidUserCount]);
  var _useState = useState({
      cbInstance: window.Chargebee.init({
        site: "workfol",
        publishableKey: "live_eEm7bmARnfvOcuCORpkc4OEECLXjEC8rW"
      })
    }),
    _useState2 = _slicedToArray(_useState, 2),
    chargebeeInstance = _useState2[0],
    setChargebeeInstance = _useState2[1];
  chargebeeInstance.cbInstance.setPortalSession(function () {
    // we have used axios for performing http requests
    // Hit your end point that returns portal session object as response
    // This sample end point will call the below api
    //apidocs.chargebee.com/docs/api/portal_sessions#create_a_portal_session
  });
  var _useMutation = useMutation(GENERATE_CHECKOUT_NEW_URL_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    generateCheckoutNewUrl = _useMutation2[0],
    newCheckoutLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(UPDATE_NEW_EMPLOYEE_TRANSACTION_DEATILS_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    updateNewEmployeeTransactionDeatils = _useMutation4[0],
    updateNewEmployeeTransactionDeatilsLoading = _useMutation4[1].loading;
  var handleCheckout = function handleCheckout(organisationId, userId, planId, userCount, totalPaidUserCount) {
    chargebeeInstance.cbInstance.openCheckout({
      hostedPage: function hostedPage() {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var data, response;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = {
                  id: user === null || user === void 0 ? void 0 : user.userId,
                  first_name: user === null || user === void 0 ? void 0 : user.displayName,
                  last_name: "",
                  email: user === null || user === void 0 ? void 0 : user.emailId,
                  currency_code: chargebeeCurrency,
                  organisationId: organisationId,
                  userCount: Number(userCount),
                  type: "employeePage",
                  planType: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planType,
                  planId: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId
                };
                _context.next = 4;
                return generateCheckoutNewUrl({
                  variables: data
                });
              case 4:
                response = _context.sent;
                if (!(!response || !response.data || response.data.generateCheckoutNewUrl == null)) {
                  _context.next = 9;
                  break;
                }
                throw new Error("error");
              case 9:
                return _context.abrupt("return", response.data.generateCheckoutNewUrl);
              case 10:
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                toast.error( /*#__PURE__*/React.createElement("div", null, "Payment gateway error, Please try again after 30 minutes to complete the payment.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Please contact our workfolio team through support chat for help."));
              case 15:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 12]]);
        }))();
      },
      loaded: function loaded() {
        // Optional
        // will be called once checkout page is loaded
      },
      error: function error(_error) {
        console.log(_error);
        // Optional
        // will be called if the promise passed causes an error
      },
      step: function step(_step) {
        console.log("checkout", _step);
      },
      success: function success() {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var userCountTemp, data, response;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                console.log("success enter");
                // try {
                userCountTemp = Number(userCount) + Number(totalPaidUserCount);
                data = {
                  organisationId: organisationId,
                  userId: userId,
                  planId: planId,
                  userCount: userCountTemp
                };
                _context2.next = 5;
                return updateNewEmployeeTransactionDeatils({
                  variables: data,
                  awaitRefetchQueries: true,
                  refetchQueries: [{
                    query: GET_PAID_AND_UNUSED_USER_COUNT_QUERY,
                    variables: {
                      organisationId: organisationId
                    }
                  }]
                });
              case 5:
                response = _context2.sent;
                if (!(!response && !response.data && response.data.updateNewEmployeeTransactionDeatils === null)) {
                  _context2.next = 11;
                  break;
                }
                toast.error("Payment failed, try again!");
                throw new Error("error");
              case 11:
                if (response.data.updateNewEmployeeTransactionDeatils === "success" || response.data.updateNewEmployeeTransactionDeatils === "in_progress") {
                  setPaymentStatus(true);
                  setInviteType(null);
                  toast.success("License added successfully!");
                  // history.push("/thankyou");
                } else if (response.data.updateNewEmployeeTransactionDeatils === "refunded") {
                  toast.success("License amount refunded!");
                } else if (response.data.updateNewEmployeeTransactionDeatils === "failure" || response.data.updateNewEmployeeTransactionDeatils === "timeout" || response.data.updateNewEmployeeTransactionDeatils === "needs_attention") {
                  toast.error("Payment failed, try again!");
                }
              case 12:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      },
      close: function close() {
        console.log("checkout new closed");
      }
    });
  };
  var checkPaidUserEmailId = function checkPaidUserEmailId() {
    // if (!paidUserCount?.getPaidAndUnusedUserCount?.paidEmailId) {
    //   return false;
    // }
    // return (paidUserCount?.getPaidAndUnusedUserCount?.paidEmailId).toLowerCase() != (user?.emailId).toLowerCase();
    return false;
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleClose,
    centered: true,
    size: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.isTrial) == false && (!paymentStatus || inviteType == "purchase-license") ? "lg" : "xl",
    contentClassName: "new-employee-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "new-user-invite-modal-type-number-of-title"
  }, "Add New Employees")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: paidUserLoading ? "new-user-invite-modal-type-loading-body" : ""
  }, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.isTrial) == false && (!paymentStatus || inviteType == "purchase-license") ? paidUserLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(React.Fragment, null, Number(paidUserCount === null || paidUserCount === void 0 ? void 0 : (_paidUserCount$getPai2 = paidUserCount.getPaidAndUnusedUserCount) === null || _paidUserCount$getPai2 === void 0 ? void 0 : _paidUserCount$getPai2.userCount) == 0 ? /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center"
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-type-number-of-license-header"
  }, "You don't have any unused licenses left to add new members.")) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: {
      span: 8
    },
    md: {
      span: 8,
      offset: 2
    },
    lg: {
      span: 8,
      offset: 2
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-type-number-of-license"
  }, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" && (role == "Admin" || role == "Head") ? /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: {
      span: 12
    },
    className: "my-1 new-user-invite-modal-type-number-of-license-text"
  }, " ", "Your plan has expired, pls visit the billing page and renew the plan before adding the new users")) : (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.paymentType) != "bank_transfer" && role == "Admin" ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: {
      span: 12
    },
    className: "my-1"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-3",
    controlId: "formBasicEmail"
  }, /*#__PURE__*/React.createElement(Form.Label, {
    className: "new-user-invite-modal-type-number-of-license-label"
  }, "Please purchase the license to add new members"), /*#__PURE__*/React.createElement(Col, {
    xs: {
      span: 4
    },
    md: {
      span: 4,
      offset: 4
    },
    lg: {
      span: 4,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    type: "number",
    min: "1"
    // placeholder="Enter number of license"
    ,
    value: userCount ? userCount : "",
    onChange: function onChange(e) {
      setUserCount(e.target.value);
    },
    required: true,
    className: "new-user-invite-modal-type-number-of-license-input",
    disabled: checkPaidUserEmailId()
  })), /*#__PURE__*/React.createElement("div", {
    type: "invalid",
    className: "new-user-invite-modal-type-number-of-license-label-error"
  }, licenseValidation ? "Please enter a valid number" : null)))), /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: {
      span: 12
    },
    className: "my-1"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "new-user-invite-modal-type-number-of-license-button",
    onClick: function onClick() {
      if (userCount != "" && Number(userCount) > 0 && !isNaN(userCount)) {
        var _paidUserCount$getPai3;
        handleCheckout(organisationId, userId, planId, userCount, paidUserCount === null || paidUserCount === void 0 ? void 0 : (_paidUserCount$getPai3 = paidUserCount.getPaidAndUnusedUserCount) === null || _paidUserCount$getPai3 === void 0 ? void 0 : _paidUserCount$getPai3.totalPaidUserCount);
      } else {
        setLicenseValidation(true);
      }
    },
    disabled: checkPaidUserEmailId()
  }, updateNewEmployeeTransactionDeatilsLoading ? "Loading ..." : "Next")))) : role == "Head" ? /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-type-number-of-license-help1"
  }, "Kindly contact your workfolio admin to purchase the required licenses. Admins can purchase the licenses from their login.") : /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-type-number-of-license-help1"
  }, "Your payment card isn't linked to your account. To proceed with purchasing additional licenses, please reach out to us through support chat or team@getworkfolio.com."), checkPaidUserEmailId() ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      span: 12
    },
    className: "my-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-type-number-of-license-help-warning"
  }, "Pls ask your workfolio admin (".concat(paidUserCount === null || paidUserCount === void 0 ? void 0 : (_paidUserCount$getPai4 = paidUserCount.getPaidAndUnusedUserCount) === null || _paidUserCount$getPai4 === void 0 ? void 0 : _paidUserCount$getPai4.paidEmailId, ") to purchase the additional license")))) : null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.paymentType) != "bank_transfer" ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      span: 12
    },
    className: "my-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-type-number-of-license-help"
  }, "If you have any questions, contact us through support chat"))) : null)))) : inviteType === null ? paidUserLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: {
      span: 12
    },
    md: {
      span: 8,
      offset: 2
    },
    lg: {
      span: 8,
      offset: 2
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-type-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-card-title"
  }, "Invite new members"), /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-type"
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-organisation-type new-user-invite-modal-type-content",
    onClick: function onClick() {
      return setInviteType("emailId");
    }
  }, /*#__PURE__*/React.createElement(MdEmail, {
    className: "new-user-invite-modal-organisation-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-organisation-name",
    onClick: function onClick() {
      return setInviteType("emailId");
    }
  }, "Invite by Email ID"), /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-footer-text"
  }, /*#__PURE__*/React.createElement("label", {
    className: "new-user-invite-modal-footer-text-data"
  }, "Enter the email to invite them to workfolio"))), /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-team-type new-user-invite-modal-type-content"
  }, /*#__PURE__*/React.createElement(MdLink, {
    className: "new-user-invite-modal-team-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-team-name",
    onClick: function onClick() {
      return setInviteType("link");
    }
  }, "Invite by Link"), /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-footer-text"
  }, /*#__PURE__*/React.createElement("label", {
    className: "new-user-invite-modal-footer-text-data"
  }, "Invite the employees through a link")))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.isTrial) == false && role == "Admin" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-card-title-license-text"
  }, "You currently have", " ", paidUserLoading ? "Loading..." : paidUserCount === null || paidUserCount === void 0 ? void 0 : (_paidUserCount$getPai5 = paidUserCount.getPaidAndUnusedUserCount) === null || _paidUserCount$getPai5 === void 0 ? void 0 : _paidUserCount$getPai5.userCount, " unused licenses available in your plan. You can add up to", " ", paidUserCount === null || paidUserCount === void 0 ? void 0 : (_paidUserCount$getPai6 = paidUserCount.getPaidAndUnusedUserCount) === null || _paidUserCount$getPai6 === void 0 ? void 0 : _paidUserCount$getPai6.userCount, " more users without any extra cost during your current plan period."), /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-card-title-license-2nd-text"
  }, "Unused licenses will not be included in your next renewal billing unless they are actively assigned to users."), /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-card-title-license-purchase-button-div"
  }, " ", (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.paymentType) != "bank_transfer" ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "new-user-invite-modal-card-title-license-purchase-button",
    onClick: function onClick() {
      return setInviteType("purchase-license");
    }
  }, "Purchase License") : /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-type-number-of-license-help2"
  }, "Please contact our team through support chat or mail to team@getworkfolio.com for adding new users."))) : (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.isTrial) == false && role == "Head" ? /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-card-title-license-text"
  }, "You have ", paidUserCount === null || paidUserCount === void 0 ? void 0 : (_paidUserCount$getPai7 = paidUserCount.getPaidAndUnusedUserCount) === null || _paidUserCount$getPai7 === void 0 ? void 0 : _paidUserCount$getPai7.userCount, " license to use in your current plan validity. For purchasing more licenses, kindly contact your workfolio admin.") : null))) : inviteType === "emailId" ? /*#__PURE__*/React.createElement(AddUserByEmail, _extends({}, props, {
    paidUserCount: paidUserCount === null || paidUserCount === void 0 ? void 0 : (_paidUserCount$getPai8 = paidUserCount.getPaidAndUnusedUserCount) === null || _paidUserCount$getPai8 === void 0 ? void 0 : _paidUserCount$getPai8.userCount,
    teamsData: teamsData === null || teamsData === void 0 ? void 0 : teamsData.organisationTeams
  })) : /*#__PURE__*/React.createElement(AddUserByInvite, _extends({}, props, {
    teamsData: teamsData === null || teamsData === void 0 ? void 0 : teamsData.organisationTeams
  }))));
});
export var RenewalPaymentPending = /*#__PURE__*/React.memo(function RenewalPaymentPendingModal(props) {
  var show = props.show,
    handleClose = props.handleClose;
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleClose,
    centered: true,
    size: "md",
    contentClassName: "new-employee-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "new-user-invite-modal-type-number-of-title"
  }, "Renewal Payment Pending")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "new-user-invite-modal-payment-pending-text"
  }, " ", "Your subscription renewal payment has failed and is currently pending. Kindly complete the payment from the", " ", /*#__PURE__*/React.createElement("strong", null, "Billing page"), " using the ", /*#__PURE__*/React.createElement("strong", null, "Pay Now"), " option. After the renewal is settled, you can proceed with adding the required number of additional licenses.")));
});
export var CustomToggle = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _onClick = _ref.onClick,
    from = _ref.from;
  return /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-date",
    ref: ref,
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick(e);
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "page-content-wrapper-menu-filter-date-text ".concat(from === "desktop" ? "page-content-wrapper-menu-filter-date-text-desktop" : "")
  }, children), /*#__PURE__*/React.createElement(GoTriangleDown, {
    className: "page-content-wrapper-menu-filter-dropdown-icon"
  }));
});
var AddUserByInvite = function AddUserByInvite(props) {
  var organisationId = props.organisationId,
    userId = props.userId,
    teamsData = props.teamsData;
  var selectedTeams = teamsData ? teamsData[0] : {};
  var _useState3 = useState(selectedTeams === null || selectedTeams === void 0 ? void 0 : selectedTeams.teamId),
    _useState4 = _slicedToArray(_useState3, 2),
    teamIdForInvite = _useState4[0],
    setTeamIdForInvite = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    inviteLink = _useState6[0],
    setInviteLink = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    inviteLinkError = _useState8[0],
    setInviteLinkError = _useState8[1];
  var _useMutation5 = useMutation(GENERATE_INVITE_LINK_QUERY),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    generateInviteLink = _useMutation6[0],
    generating = _useMutation6[1].loading;
  var generateLinkSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(teamIdForTemp, setInviteLink, userId) {
      var response, _errorMessage, normalisedMessage;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!generating) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            setInviteLinkError("");
            _context3.prev = 3;
            _context3.next = 6;
            return generateInviteLink({
              variables: {
                teamId: teamIdForTemp,
                userId: userId
              },
              refetchQueries: [{
                query: GET_INVITE_LINK_HISTORY_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 6:
            response = _context3.sent;
            if (response.data.generateInviteLink) {
              setInviteLink(response.data.generateInviteLink);
            }
            _context3.next = 15;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](3);
            _errorMessage = (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) || ""; // Compared in lower case: the backend throws "License count not exist."
            // with a leading capital, and includes() is case-sensitive.
            normalisedMessage = _errorMessage.toLowerCase();
            if (normalisedMessage.includes("license count not exist")) {
              // Thrown by checkUserStatusForFreeOrTrialPlan (backend
              // graphql/models/user.js) when a paid org has no unused licences left.
              // Matched without the "GraphQL error: " prefix so it holds either way.
              setInviteLinkError("All your paid licenses are currently in use. Please purchase additional licenses to invite more team members, or contact us through Support Chat or email (team@getworkfolio.com).");
            } else if (_errorMessage.includes("invite links already exist")) {
              // Checked before the generic "already exist" branch below, which would
              // otherwise show the server's raw wording.
              setInviteLinkError("For security and to prevent automated abuse, this organization already has more than 20 active invite links created within the last 15 minutes. Please try again after 15 minutes.");
            } else if (_errorMessage.includes("already exist")) {
              setInviteLinkError(_errorMessage.replace("GraphQL error: ", ""));
            } else {
              setInviteLinkError("Something went wrong! Please try again later.");
            }
          case 15:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 10]]);
    }));
    return function generateLinkSubmit(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "invite-user-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "invite-user-team-header"
  }, /*#__PURE__*/React.createElement("label", null, "Choose a team to generate the team member invite link"), /*#__PURE__*/React.createElement("div", {
    className: "invite-user-team-generate-link mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "invite-user-team-filter "
  }, /*#__PURE__*/React.createElement("select", {
    className: "form-control",
    name: "teamNameList",
    onChange: function onChange(event) {
      return setTeamIdForInvite(event.target.value);
    }
  }, teamsData.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      value: item.teamId
    }, " ", item.teamName);
  }))), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "invite-user-generate-link-button",
    size: "sm",
    onClick: function onClick() {
      return generateLinkSubmit(teamIdForInvite, setInviteLink, userId);
    }
  }, "Generate Invite Link")), inviteLinkError ? /*#__PURE__*/React.createElement("p", {
    className: "invite-user-generate-link-error"
  }, inviteLinkError) : null, inviteLink ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "invite-user-generate-link-text"
  }, "Nice, here is newly generated invited link", /*#__PURE__*/React.createElement("a", {
    className: "invite-user-generate-link-text-link",
    href: "https://app.getworkfolio.com/signup/".concat(inviteLink),
    rel: "noreferrer",
    target: "_blank",
    "data-saferedirecturl": "https://app.getworkfolio.com/signup/".concat(inviteLink)
  }, "https://app.getworkfolio.com/signup/", inviteLink)), /*#__PURE__*/React.createElement("div", {
    className: "invite-user-generate-link-what-next"
  }, /*#__PURE__*/React.createElement("label", {
    className: "invite-user-generate-link-what-next-title"
  }, "What Next"), /*#__PURE__*/React.createElement("div", {
    className: "invite-user-generate-link-what-next-step"
  }, /*#__PURE__*/React.createElement("div", null, "Step 1: Share the invite link with your team. "), /*#__PURE__*/React.createElement("div", null, "Step 2: Your Employee need to click this link and complete the signup to join your team ")), /*#__PURE__*/React.createElement("div", {
    className: "invite-user-generate-link-what-next-step-help"
  }, "The invited employee will be joined as a team member. You can change the roles later.", " "))) : null), /*#__PURE__*/React.createElement(InviteLinkList, {
    organisationId: organisationId
  }));
};
var InviteLinkList = function InviteLinkList(props) {
  var _invitLinkHistoryData, _invitLinkHistoryData2, _invitLinkHistoryData3;
  var organisationId = props.organisationId;
  var isWindow = typeof window !== "undefined";
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    copySuccess = _useState10[0],
    setCopySuccess = _useState10[1];
  var _useQuery3 = useQuery(GET_INVITE_LINK_HISTORY_QUERY, {
      variables: {
        organisationId: organisationId
      }
    }),
    invitLinkHistoryData = _useQuery3.data,
    invitLinkHistoryError = _useQuery3.error,
    invitLinkHistoryLoading = _useQuery3.loading;
  var copyToClipBoard = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(copyMe) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return navigator.clipboard.writeText(copyMe);
          case 3:
            setCopySuccess("Copied!");
            toast.success("Copied!");
            _context4.next = 12;
            break;
          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            console.log(_context4.t0);
            setCopySuccess("Failed to copy!");
            toast.error("Failed to copy!");
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 7]]);
    }));
    return function copyToClipBoard(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "invite-user-generate-link-history-table-content"
  }, (invitLinkHistoryData === null || invitLinkHistoryData === void 0 ? void 0 : (_invitLinkHistoryData = invitLinkHistoryData.getInviteLinkHistory) === null || _invitLinkHistoryData === void 0 ? void 0 : _invitLinkHistoryData.length) !== 0 ? /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    hover: true,
    className: "invite-user-generate-link-history-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Team Name"), /*#__PURE__*/React.createElement("th", null, "Invite Link"), /*#__PURE__*/React.createElement("th", null, "Status"))), /*#__PURE__*/React.createElement("tbody", null, invitLinkHistoryData === null || invitLinkHistoryData === void 0 ? void 0 : (_invitLinkHistoryData2 = invitLinkHistoryData.getInviteLinkHistory) === null || _invitLinkHistoryData2 === void 0 ? void 0 : _invitLinkHistoryData2.map(function (inviteHistory, key) {
    var isActiveCheck = moment(inviteHistory.tokenExpireTime) < moment() ? "Expired" : "Active";
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, inviteHistory.teamName), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "invite-token-data"
    }, window.innerWidth > 768 && isWindow ? /*#__PURE__*/React.createElement("span", {
      className: "invite-token-link-text"
    }, "https://app.getworkfolio.com/signup/", inviteHistory.inviteToken, " ") : null, isActiveCheck === "Active" ? /*#__PURE__*/React.createElement(React.Fragment, null, window.innerWidth > 768 && isWindow ? /*#__PURE__*/React.createElement(Button, {
      className: "invite-token-copy-button",
      variant: "link",
      onClick: function onClick() {
        return copyToClipBoard("https://app.getworkfolio.com/signup/".concat(inviteHistory.inviteToken));
      }
    }, "Copy") : /*#__PURE__*/React.createElement(Button, {
      className: "invite-token-copy-button",
      variant: "link",
      onClick: function onClick() {
        return copyToClipBoard("https://app.getworkfolio.com/signup/".concat(inviteHistory.inviteToken));
      }
    }, "Copy invite link")) : window.innerWidth > 768 && isWindow ? null : /*#__PURE__*/React.createElement(Button, {
      className: "invite-token-copy-button",
      variant: "link",
      onClick: function onClick() {
        return copyToClipBoard("https://app.getworkfolio.com/signup/".concat(inviteHistory.inviteToken));
      }
    }, "Copy invite link"))), /*#__PURE__*/React.createElement("td", null, isActiveCheck));
  }), (invitLinkHistoryData === null || invitLinkHistoryData === void 0 ? void 0 : (_invitLinkHistoryData3 = invitLinkHistoryData.getInviteLinkHistory) === null || _invitLinkHistoryData3 === void 0 ? void 0 : _invitLinkHistoryData3.length) === 0 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: "3"
  }, "No invite link found !!!")) : null)) : null, /*#__PURE__*/React.createElement("div", {
    className: "invite-user-generate-link-expire"
  }, "* Generated invite link will auto-expire in 7 days"));
};
var AddUserByEmail = function AddUserByEmail(props) {
  var handleClose = props.handleClose,
    roles = props.roles,
    teams = props.teams,
    teamId = props.teamId,
    userId = props.userId,
    organisationBilling = props.organisationBilling,
    employeeCount = props.employeeCount,
    paidUserCount = props.paidUserCount,
    role = props.role,
    teamsData = props.teamsData;
  var _React$useContext3 = React.useContext(FilterContext),
    organisationId = _React$useContext3.organisationId;
  var _React$useContext4 = React.useContext(SearchContext),
    search = _React$useContext4.search;
  var _useMutation7 = useMutation(ADD_USER_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    addUsers = _useMutation8[0],
    adding = _useMutation8[1].loading;
  var onAddUsers = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(values, actions) {
      var users, emailIdCount, duplicates;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!adding) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            users = values.users;
            emailIdCount = {};
            duplicates = [];
            users.forEach(function (user) {
              emailIdCount[user.email] = (emailIdCount[user.email] || 0) + 1;
            });

            // Find all objects with duplicate `team_id`
            users.forEach(function (user) {
              if (emailIdCount[user.email] > 1) {
                duplicates.push(user);
              }
            });
            if (!duplicates.length) {
              _context5.next = 10;
              break;
            }
            actions.setFieldError("formError", "Employee Email must be unique!");
            return _context5.abrupt("return", false);
          case 10:
            _context5.prev = 10;
            _context5.next = 13;
            return addUsers({
              variables: {
                users: users,
                organisationId: organisationId
              },
              update: function update(cache, _ref5) {
                var data = _ref5.data;
                var newUsers = data === null || data === void 0 ? void 0 : data.addUsers;
                if (!(newUsers !== null && newUsers !== void 0 && newUsers.length)) return;
                var usersToAdd = newUsers.map(function (u) {
                  return _objectSpread(_objectSpread({}, u), {}, {
                    passwordStatus: false,
                    organisationCreatedBy: null,
                    appVersion: null,
                    billableRate: null,
                    appIcon: null,
                    labourCost: null,
                    billableRateType: null,
                    labourCostType: null,
                    userRole: null,
                    dateOfBirth: null,
                    dateOfJoining: null,
                    designation: null
                  });
                });
                cache.modify({
                  fields: {
                    organisationUsers: function organisationUsers() {
                      var existing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                      return [].concat(_toConsumableArray(usersToAdd), _toConsumableArray(existing));
                    },
                    organisationUsersCount: function organisationUsersCount(existing) {
                      if (!existing) return existing;
                      return _objectSpread(_objectSpread({}, existing), {}, {
                        userCount: (parseInt(existing.userCount) || 0) + newUsers.length
                      });
                    }
                  }
                });
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: ORGANISATION_DETAILS_QUERY,
                variables: {
                  userId: userId
                }
              }, {
                query: GET_PAID_AND_UNUSED_USER_COUNT_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }, {
                query: ORGANISATION_USERS_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userRole: role
                }
              }, {
                query: TEAM_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 13:
            toast.success( /*#__PURE__*/React.createElement("div", null, "Your team member has received an email with an invite link from us.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Please advise them to check their promotion/spam folders if they didn't receive the invitation mail."));
            handleClose();
            _context5.next = 20;
            break;
          case 17:
            _context5.prev = 17;
            _context5.t0 = _context5["catch"](10);
            // A 429 arrives as an Apollo network error, so its reason is not in
            // error.message and would fall through to the generic branch below. The
            // bulk-write limiter uses a one-hour window, unlike the login one.
            if (isRateLimited(_context5.t0)) {
              actions.setFieldError("formError", "Too many user changes in a short time. Please try again in an hour.");
            } else if (_context5.t0.message.includes("already registered")) {
              actions.setFieldError("formError", _context5.t0.message);
            } else if (_context5.t0.message.includes("more than 200 users are not allowed")) {
              actions.setFieldError("formError", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "You've reached the 200-user limit"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
                style: {
                  fontWeight: 400
                }
              }, "For security and to prevent automated abuse, Free plan workspaces can add up to 200 users by default.", /*#__PURE__*/React.createElement("br", null), "If you need to add more users, please contact us through Support Chat or email (team@getworkfolio.com).", /*#__PURE__*/React.createElement("br", null), "We're happy to review your workspace and increase the limit for legitimate use.")));
            } else if ((_context5.t0.message || "").toLowerCase().includes("license count not exist")) {
              // checkUserStatusForFreeOrTrialPlan (backend graphql/models/user.js)
              // throws this for a paid org with no unused licences left. Kept out of
              // the generic branch below: waiting ten minutes does not help here.
              actions.setFieldError("formError", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "No licenses available"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
                style: {
                  fontWeight: 400
                }
              }, "All the licenses on your plan are currently in use, so no further team members can be added.", /*#__PURE__*/React.createElement("br", null), "Please purchase additional licenses, or contact us through Support Chat or email (team@getworkfolio.com) and we'll help you upgrade.")));
            } else {
              actions.setFieldError("formError", "Error occurred, Please try again after 10 mins to complete the action.");
            }
          case 20:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[10, 17]]);
    }));
    return function onAddUsers(_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();

  // teamsData={teamsData?.organisationTeams}
  var isMobileView = window.innerWidth < 768;
  return /*#__PURE__*/React.createElement(Formik, {
    onSubmit: onAddUsers,
    initialValues: defaultValues,
    validationSchema: AddUsersSchema
  }, function (_ref6) {
    var values = _ref6.values,
      errors = _ref6.errors,
      touched = _ref6.touched,
      isSubmitting = _ref6.isSubmitting;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(FieldArray, {
      name: "users",
      render: function render(userArrayHelpers) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, values.users.map(function (user, userIndex) {
          var _errors$users, _errors$users$userInd, _touched$users, _touched$users$userIn;
          var emailError = errorMessage(errors, touched, "users[".concat(userIndex, "].email"));
          var displayNameError = errorMessage(errors, touched, "users[".concat(userIndex, "].displayName"));
          var employeeIdError = errorMessage(errors, touched, "users[".concat(userIndex, "].employeeId"));
          return /*#__PURE__*/React.createElement(Form.Row, {
            className: "border-bottom employee-row py-4"
          }, /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 6,
            md: 3,
            className: "mb-2"
          }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
            className: "add-email-label"
          }, "Employee Name", /*#__PURE__*/React.createElement("span", {
            "class": "add-employee-modal-form-employee-label-name-required"
          }, " *")), /*#__PURE__*/React.createElement(Field, {
            as: Form.Control,
            name: "users[".concat(userIndex, "].displayName"),
            type: "text",
            required: true,
            placeholder: "Enter employee name",
            isInvalid: displayNameError != null
          }), displayNameError)), /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 6,
            md: 3,
            className: "mb-2"
          }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
            className: "add-email-label"
          }, "Employee Email", " ", /*#__PURE__*/React.createElement("span", {
            "class": "add-employee-modal-form-employee-label-name-required"
          }, " *")), /*#__PURE__*/React.createElement(Field, {
            as: Form.Control,
            name: "users[".concat(userIndex, "].email"),
            type: "email",
            required: true,
            placeholder: "Enter employee email",
            isInvalid: emailError != null
          }), emailError)), /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 6,
            md: 2,
            className: "mb-2"
          }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
            className: "add-email-label"
          }, "Employee ID", " ", /*#__PURE__*/React.createElement("span", {
            className: "add-employee-modal-form-employee-id-label"
          }, "(Optional)")), /*#__PURE__*/React.createElement(Field, {
            as: Form.Control,
            name: "users[".concat(userIndex, "].employeeId"),
            type: "text",
            placeholder: "Enter Employee Id",
            isInvalid: employeeIdError != null
          }), employeeIdError)), /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 6,
            md: 4,
            className: "mb-2"
          }, /*#__PURE__*/React.createElement(FieldArray, {
            name: "users[".concat(userIndex, "].teams"),
            render: function render(teamArrayHelpers) {
              return /*#__PURE__*/React.createElement(React.Fragment, null, user.teams.map(function (_team, teamIndex) {
                var roleIdError = errorMessage(errors, touched, "users[".concat(userIndex, "].teams[").concat(teamIndex, "].roleId"));
                var teamIdError = errorMessage(errors, touched, "users[".concat(userIndex, "].teams[").concat(teamIndex, "].teamId"));
                return /*#__PURE__*/React.createElement(Form.Row, {
                  key: "team-".concat(teamIndex)
                }, /*#__PURE__*/React.createElement(Col, {
                  xs: 9,
                  sm: 4,
                  className: "mb-2"
                }, /*#__PURE__*/React.createElement(Field, {
                  name: "users[".concat(userIndex, "].teams[").concat(teamIndex, "].roleId")
                }, function (_ref7) {
                  var field = _ref7.field,
                    form = _ref7.form;
                  var onChange = field.onChange,
                    restField = _objectWithoutProperties(field, _excluded);
                  return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
                    className: "add-email-label"
                  }, "Role", " ", /*#__PURE__*/React.createElement("span", {
                    "class": "add-employee-modal-form-employee-label-name-required"
                  }, " ", "*")), /*#__PURE__*/React.createElement(Form.Control, _extends({
                    as: "select",
                    defaultValue: "",
                    required: true
                  }, restField, {
                    onChange: function onChange(e) {
                      form.setFieldValue("users[".concat(userIndex, "].teams[").concat(teamIndex, "].roleId"), e.target.value);
                      if (e.target.value === "24e4b513-da16-44e8-92ff-d28fcdc0d17f") {
                        form.setFieldValue("users[".concat(userIndex, "].teams[").concat(teamIndex, "].teamId"), "allTeam");
                      } else {
                        // form.setFieldValue(
                        //   `users[${userIndex}].teams[${teamIndex}].teamId`,
                        //   ""
                        // );
                      }
                    },
                    isInvalid: roleIdError != null
                  }), /*#__PURE__*/React.createElement("option", {
                    value: ""
                  }, "Role..."), roles === null || roles === void 0 ? void 0 : roles.map(function (roleOption) {
                    if (role == "Head") {
                      return /*#__PURE__*/React.createElement(React.Fragment, null, roleOption.roleName == "Member" ? /*#__PURE__*/React.createElement("option", {
                        value: roleOption.roleId
                      }, "Team Member") : null);
                    } else if (userIndex === 0 || userIndex > 1 && roleOption.roleId !== "24e4b513-da16-44e8-92ff-d28fcdc0d17f") {
                      return /*#__PURE__*/React.createElement("option", {
                        value: roleOption.roleId
                      }, " ", roleOption.roleName === "Head" ? "Team Head" : roleOption.roleName === "Member" ? "Team Member" : roleOption.roleName);
                    } else {
                      return /*#__PURE__*/React.createElement("option", {
                        value: roleOption.roleId
                      }, " ", roleOption.roleName === "Head" ? "Team Head" : roleOption.roleName === "Member" ? "Team Member" : roleOption.roleName);
                    }
                  })), roleIdError);
                })), /*#__PURE__*/React.createElement(Col, {
                  xs: 12,
                  sm: 7,
                  className: "mb-2"
                }, /*#__PURE__*/React.createElement(Field, {
                  name: "users[".concat(userIndex, "].teams[").concat(teamIndex, "].teamId")
                }, function (_ref8) {
                  var field = _ref8.field;
                  return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
                    className: "add-email-label"
                  }, "Team Name", " ", /*#__PURE__*/React.createElement("span", {
                    "class": "add-employee-modal-form-employee-label-name-required"
                  }, " ", "*")), /*#__PURE__*/React.createElement(Form.Control, _extends({
                    as: "select",
                    defaultValue: "",
                    required: true
                  }, field, {
                    isInvalid: teamIdError != null,
                    disabled: user.teams[teamIndex].roleId === "24e4b513-da16-44e8-92ff-d28fcdc0d17f" ? true : false
                  }), user.teams[teamIndex].roleId === "24e4b513-da16-44e8-92ff-d28fcdc0d17f" ? /*#__PURE__*/React.createElement("option", {
                    value: "allTeam"
                  }, "All Team") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("option", {
                    value: ""
                  }, "Team..."), teamsData.map(function (team) {
                    return /*#__PURE__*/React.createElement("option", {
                      value: team.teamId
                    }, team.teamName);
                  }))), teamIdError);
                })), values.users.length > 1 && teamIndex === 0 ? /*#__PURE__*/React.createElement(Col, {
                  xs: 4,
                  sm: 4,
                  className: "mb-2 d-flex align-items-center justify-content-center"
                }, /*#__PURE__*/React.createElement(Button, {
                  variant: "link",
                  className: "mt-3",
                  size: "sm",
                  onClick: function onClick() {
                    return userArrayHelpers.remove(userIndex);
                  }
                }, "Remove User")) : user.teams.length > 1 ? /*#__PURE__*/React.createElement(Col, {
                  xs: 4,
                  sm: 4,
                  className: "mb-2 d-flex align-items-center justify-content-center"
                }, /*#__PURE__*/React.createElement(Button, {
                  variant: "link",
                  className: "mt-3",
                  size: "sm",
                  onClick: function onClick() {
                    return teamArrayHelpers.remove(teamIndex);
                  }
                }, "Remove Team")) : null);
              }), isMobileView ? null : /*#__PURE__*/React.createElement(Button, {
                variant: "link",
                className: "add-another-team-button",
                onClick: function onClick() {
                  return teamArrayHelpers.push({
                    teamId: "",
                    roleId: ""
                  });
                }
              }, "+ Add to another team"));
            }
          }), typeof ((_errors$users = errors.users) === null || _errors$users === void 0 ? void 0 : (_errors$users$userInd = _errors$users[userIndex]) === null || _errors$users$userInd === void 0 ? void 0 : _errors$users$userInd.teams) === "string" && ((_touched$users = touched.users) === null || _touched$users === void 0 ? void 0 : (_touched$users$userIn = _touched$users[userIndex]) === null || _touched$users$userIn === void 0 ? void 0 : _touched$users$userIn.teams) && /*#__PURE__*/React.createElement("div", {
            className: "text-danger mt-1"
          }, errors.users[userIndex].teams)));
        }), isMobileView || organisationBilling.userCount !== 0 && Number(employeeCount) + Number(values.users.length) >= organisationBilling.userCount || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" && Number(values.users.length) >= Number(paidUserCount) ? null : /*#__PURE__*/React.createElement(Button, {
          variant: "link",
          onClick: function onClick() {
            return userArrayHelpers.push({
              displayName: "",
              email: "",
              teams: [{
                teamId: "",
                roleId: ""
              }]
            });
          }
        }, "+ Add another user"));
      }
    }), /*#__PURE__*/React.createElement(Modal.Footer, {
      className: "new-employee-modal-footer"
    }, typeof errors.users === "string" ? /*#__PURE__*/React.createElement("div", {
      className: "form-error"
    }, errors.users) : null, isMobileView ? null : /*#__PURE__*/React.createElement("div", {
      className: "new-employee-modal-footer-help"
    }, /*#__PURE__*/React.createElement("div", {
      className: "new-employee-modal-footer-help-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "new-employee-modal-footer-help-text-role"
    }, "Team Member"), " is a person who you want to be monitored"), /*#__PURE__*/React.createElement("div", {
      className: "new-employee-modal-footer-help-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "new-employee-modal-footer-help-text-role"
    }, "Team Head"), " can see their team members' tracking data in workfolio website"), /*#__PURE__*/React.createElement("div", {
      className: "new-employee-modal-footer-help-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "new-employee-modal-footer-help-text-role"
    }, "Admin"), " has the control of everything from adding a member, creating a team, seeing the tracking data")), /*#__PURE__*/React.createElement("div", {
      className: "new-employee-modal-footer-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "light",
      onClick: handleClose,
      disabled: isSubmitting || adding
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      disabled: isSubmitting || adding,
      type: "submit"
    }, adding ? "Adding..." : "Add & Invite User".concat(values.users.length !== 0 ? "s" : ""))), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error employee-add-modal-error"
    }, errors.formError) : null, isMobileView ? /*#__PURE__*/React.createElement("div", {
      className: "new-employee-modal-footer-help"
    }, /*#__PURE__*/React.createElement("p", {
      className: "new-employee-modal-footer-help-title"
    }, "Roles Explanation: "), /*#__PURE__*/React.createElement("div", {
      className: "new-employee-modal-footer-help-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "new-employee-modal-footer-help-text-role"
    }, "Team Member"), " is a person who you want to be monitored"), /*#__PURE__*/React.createElement("div", {
      className: "new-employee-modal-footer-help-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "new-employee-modal-footer-help-text-role"
    }, "Team Head"), " can see their team members' tracking data in workfolio website"), /*#__PURE__*/React.createElement("div", {
      className: "new-employee-modal-footer-help-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "new-employee-modal-footer-help-text-role"
    }, "Admin"), " has the control of everything from adding a member, creating a team, seeing the tracking data")) : null));
  });
};